import ListCreateButton from 'components/buttons/ListCreateButton';
import { useOpenCreateUrl } from 'components/create-dialog/CreateDialogContext';
import PageHeader from 'components/PageHeader';
import PaddedLayout from 'layout/MainLayout/PaddedLayout';
import MarketingProfilesTable from './MarketingProfilesTable';

const MarketingProfilesPage = () => {
    const openCreateUrl = useOpenCreateUrl();

    return (
        <PaddedLayout className="overflow-hidden">
            <div className="flex h-full flex-col gap-4">
                <PageHeader
                    hostsList
                    titleId="marketing-profiles.profiles"
                    showBreadcrumb
                    buttons={
                        <ListCreateButton
                            permissions={['CREATE.MARKETING_PROFILE']}
                            variant="contained"
                            color="secondary"
                            size="small"
                            onClick={() => openCreateUrl('/contacts/marketing/new')}
                            labelId="marketing-profiles.new-profile"
                            newLabelId="marketing-profiles.new-profile"
                        />
                    }
                />
                <MarketingProfilesTable />
            </div>
        </PaddedLayout>
    );
};

export default MarketingProfilesPage;
